<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="30vw">
    <v-card>
      <v-card-title>
        <span class="headline">申請内容</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-layout column mb-4>
            <v-flex class="label">予算</v-flex>
            <v-flex class="value"
              ><AppCurrency :value="request.budget" :currency="currency"
            /></v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">使用可能期間</v-flex>
            <v-flex class="value">
              <AppPeriod :start="startTime" :end="endTime" />
            </v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">申請種別</v-flex>
            <v-flex class="value"
              ><Type :type="request.requestType" with-color
            /></v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">ステータス</v-flex>
            <v-flex class="value"
              ><Status
                :status="request.requestStatus"
                with-color
                perspective="agency"
            /></v-flex>
          </v-layout>
          <v-layout v-if="request.reason" column mb-4>
            <v-flex class="label">却下理由</v-flex>
            <v-flex class="value">{{ request.reason }}</v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('input', false)">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Status from '@/components/Shared/Presentation/Request/Status'
import Type from '@/components/Shared/Presentation/Request/Type'

export default {
  name: 'LatestRequestModal',
  components: { Status, Type },
  props: { value: Boolean, budget: Object, currency: String },
  computed: {
    request() {
      return this.budget.latestRequest
    },
    startTime() {
      if (this.request.requestStatus === 'waiting') {
        return this.request.startTime
      }
      return this.budget.startTime
    },
    endTime() {
      if (this.request.requestStatus === 'waiting') {
        return this.request.endTime
      }
      return this.budget.endTime
    },
  },
}
</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.value {
  font-size: 16px;
}
</style>
